import { render, staticRenderFns } from "./NormalSearchNav206.vue?vue&type=template&id=0bd68e54&scoped=true"
import script from "./NormalSearchNav206.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav206.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd68e54",
  null
  
)

export default component.exports